import { create } from 'zustand';
import type { Location } from 'react-router-dom';

interface OperationalBlock {
  owner: string;
  identity: string;
  location: Location;
}
export interface OperationalExit extends OperationalBlock {
  finish: () => Promise<unknown>;
  errorTitle: string;
  errorDescription: string;
  retryLabel: string;
  leaveLabel: string;
}
interface OperationalNavigationState {
  exit: OperationalExit | null;
  registerExit: (exit: OperationalExit) => void;
  releaseExit: (owner: string) => void;
  block: OperationalBlock | null;
  securityPaused: boolean;
  acquire: (block: OperationalBlock) => void;
  release: (owner: string) => void;
}
export const useOperationalNavigationStore = create<OperationalNavigationState>((set) => ({
  block: null,
  exit: null,
  registerExit: (exit) => set({ exit }),
  releaseExit: (owner) => set((s) => (s.exit?.owner === owner ? { exit: null } : s)),
  securityPaused: false,
  acquire: (block) => set((s) => (s.block && s.block.owner !== block.owner ? s : { block })),
  release: (owner) => set((s) => (s.block?.owner === owner ? { block: null } : s)),
}));
